// Quote-engine price-item keys that are now edited exclusively in the Pricing panel.
// Mirrors backend/pricing_catalog.py. Used to strip these keys (and price_titles)
// from the SettingsEditor save payload so the two panels never overwrite each other.
export const PRICING_KEYS = [
  "base_price", "area_rate_per_sqm", "felt_roof_per_sqm", "grp_roof_per_sqm",
  "render_rate_per_sqm", "tiled_roof_saving", "skylight_each", "skylight_labour",
  "window_large_surcharge", "bifold_base", "bifold_per_lm", "hob_gas_surcharge",
  "boiler_move", "boiler_new", "floor_lvt", "floor_lvt_per_sqm", "floor_tiles",
  "floor_tiles_per_sqm", "kitchen_install", "addon_kitchen_removal", "addon_replaster",
  "addon_reflooring", "radiator_each", "underfloor_heating_per_sqm", "extra_window_each",
  "roof_lantern_each", "addon_wc", "addon_full_bathroom", "extra_external_pipe",
  "extra_external_socket", "extra_wall_light", "spotlights_1_6", "spotlights_7_10",
  "spotlights_11_plus", "undercabinet_lights", "ulez_per_day", "no_driveway_parking_total",
  "rear_access_muckaway", "demolish_base", "demolish_per_sqm", "steel_beam_remove_rear_wall",
  "build_over_agreement", "footings_extra_per_m3", "skip_extra_each",
];
